export const GAME_CATALOG = [
  {
    id: "quem-sou-eu",
    nome: "Quem Sou Eu?",
    imagem: "/imagens/capa-quem-sou-eu.jpg",
    descricao:
      "Dê dicas para o jogador sorteado adivinhar quem é o personagem!",
    emBreve: false,
  },
  {
    id: "termo",
    nome: "Termo Multiplayer",
    imagem: "/imagens/capa-termo.jpg",
    descricao:
      "Descubra a palavra secreta. Jogue com 1, 2 ou 4 palavras simultâneas!",
    emBreve: false,
  },
  {
    id: "quebra-cabeca",
    nome: "Quebra-Cabeça",
    imagem: "/imagens/capa-quebra-cabeca.jpg",
    descricao:
      "Monte a imagem no menor tempo possível e mostre que você é o mais rápido!",
    emBreve: false,
  },
  {
    id: "stop",
    nome: "Stop",
    imagem: "/imagens/capa-stop.jpg",
    descricao:
      "Sorteou a letra, é só preencher todas as categorias antes de alguém gritar STOP!",
    emBreve: false,
  },
  {
    id: "jogo-secreto",
    nome: "Em Breve...",
    imagem: "/imagens/capa-em-breve.jpg",
    descricao: "Novos minigames estão sendo desenvolvidos.",
    emBreve: true,
  },
];
